import React, { useMemo } from 'react';
import { Card } from 'react-bootstrap';
import classNames from 'classnames';
import { GoalBase, GoalId } from '../types';
import { GoalWeightValidation } from '../useGoalWeightValidation';
import { GoalCardItem } from '../GoalStatusCard/GoalCardItem';
import { groupGoalsByEmployee } from './groupLogic';
import { EmployeeGroupHeader } from './EmployeeGroupHeader';

type Props = {
  goals: GoalBase[];
  goalWeightValidation: GoalWeightValidation;
  onlyInvalidWeights: boolean;
  onGoalClick: (goalId: GoalId) => void;
};

export const GoalsListGroupedByEmployee: React.FC<
  React.PropsWithChildren<Props>
> = ({ goals, goalWeightValidation, onlyInvalidWeights, onGoalClick }) => {
  const { getErrorsForEmployee } = goalWeightValidation;

  const visibleGroups = useMemo(() => {
    const grouped = groupGoalsByEmployee(goals);
    if (!onlyInvalidWeights) {
      return Array.from(grouped.values());
    }
    return Array.from(grouped.values()).filter(
      (g) => getErrorsForEmployee(g.employee.id).length > 0,
    );
  }, [goals, onlyInvalidWeights, getErrorsForEmployee]);

  return (
    <div>
      {visibleGroups.map(({ employee, goals: employeeGoals }) => (
        <Card key={employee.id} className="mb-3">
          <Card.Body>
            <EmployeeGroupHeader
              employee={employee}
              goalIds={employeeGoals.map((g) => g.id)}
              errors={getErrorsForEmployee(employee.id)}
            />
            <div className={classNames('d-flex', 'flex-column', 'gap-3')}>
              {employeeGoals.map((goal) => (
                <GoalCardItem key={goal.id} goal={goal} onClick={onGoalClick} />
              ))}
            </div>
          </Card.Body>
        </Card>
      ))}
    </div>
  );
};
